export const getMaxFileSizeBytes = (sizeInMB: number): number => sizeInMB * 1024 * 1024;
